import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Pricing = () => {
    const navigate = useNavigate();

    return (
        <div className="wrapper">
            <div id="content-wrap">
                <Navbar />
                <div className="d-flex flex-column justify-content-center align-items-center background-grid" style={{ marginTop: "100px" }}>
                    <h2>Ready to level up?</h2>
                    <p className='text-center w-75' style={{ minWidth: "320px", maxWidth: "700px" }}>
                        Build your foundation with a complete course designed to help you understand the bigger picture of Melee.
                    </p>
                    {/* <p className='text-center' style={{ width: "800px" }}>
                        <span><b>Choose how long you’d like access and learn at your own pace:</b></span>
                    </p> */}
                    <div className="d-flex flex-wrap justify-content-center gap-4 w-md-100 mt-4" style={{ minWidth: "320px", maxWidth: "1350px" }}>
                        {/* One Month Access */}
                        <div className="rounded p-5 d-flex flex-column w-50" style={{ backgroundColor: "#0B0E1E", minWidth: "320px", maxWidth: "420px", border: "1px solid #E5E5E5", height: "420px" }}>
                            <h3 className="text-center">1-Month Access</h3>
                            <p className="text-center m-0 pb-2"><span style={{ fontWeight: 600, fontSize: "22px" }}>$25</span> USD</p>
                            <p className="m-0">Full access to the foundation course:</p>
                            <ul>
                                <li>4 sections</li>
                                <li>23 video lessons</li>
                                <li>Great if you plan to study intensively or review quickly.</li>
                            </ul>
                            <button
                                className="rounded w-100 mt-auto" // Use mt-auto to push the button to the bottom
                                style={{ backgroundColor: "#FFCC19", height: "45px", fontWeight: 600, border: "none", color: "black" }}
                                onClick={() => navigate('/pricing/subscribe/one-month')}
                            >
                                Get Access
                            </button>
                        </div>

                        {/* Two Month Access */}
                        <div className="rounded p-5 d-flex flex-column w-50" style={{ backgroundColor: "#0B0E1E", minWidth: "320px", maxWidth: "420px", border: "1px solid #E5E5E5", height: "420px" }}>
                            <h3 className="text-center">2-Month Access</h3>
                            <p className="text-center m-0 pb-2"><span style={{ fontWeight: 600, fontSize: "22px" }}>$40</span> USD</p>
                            <p className="m-0">Full foundation course access for two months:</p>
                            <ul>
                                <li>Same content, extended viewing time</li>
                                <li>Ideal if you want to pace your learning slowly</li>
                            </ul>
                            <button
                                className="rounded w-100 mt-auto" // Use mt-auto to push the button to the bottom
                                style={{ backgroundColor: "#FFCC19", height: "45px", fontWeight: 600, border: "none", color: "black" }}
                                onClick={() => navigate('/pricing/subscribe/two-months')}
                            >
                                Get Access
                            </button>
                        </div>

                        {/* Three Month Access */}
                        <div className="rounded p-5 d-flex flex-column justify-content-stretch w-50" style={{ backgroundColor: "#0B0E1E", minWidth: "320px", maxWidth: "420px", border: "1px solid #E5E5E5", height: "420px" }}>
                            <h3 className="text-center">3-Month Access</h3>
                            <p className="text-center m-0 pb-2"><span style={{ fontWeight: 600, fontSize: "22px" }}>$60</span> USD</p>
                            <p className="m-0">Full foundation course access for three months:</p>
                            <ul>
                                <li>Same lessons, longer time window</li>
                                <li>Perfect if you like to digest content while learning in-between tournaments.</li>
                            </ul>
                            <button
                                className="rounded w-100 mt-auto" // Use mt-auto to push the button to the bottom
                                style={{ backgroundColor: "#FFCC19", height: "45px", fontWeight: 600, border: "none", color: "black" }}
                                onClick={() => navigate('/pricing/subscribe/three-months')}
                            >
                                Get Access
                            </button>
                        </div>

                        {/* Pro Plan */}
                        {/* <div className="rounded p-5 d-flex flex-column" style={{ backgroundColor: "#0B0E1E", width: "420px", border: "1px solid #E5E5E5", height: "400px" }}>
                            <h3 className="text-center">Pro Plan</h3>
                            <p className="text-center m-0 pb-2"><span style={{ fontWeight: 600, fontSize: "22px" }}>TBA</span>/month</p>
                            <p className="m-0">Advanced content and features in development. To learn more, checkout all the foundation introduction videos to learn more under tutorials.</p>
                            <button
                                className="rounded w-100 mt-auto" // Use mt-auto to push the button to the bottom
                                style={{ backgroundColor: "#AEAFBA", height: "45px", color: 'white', fontWeight: 600 }}
                            >
                                Coming Soon
                            </button>
                        </div> */}
                    </div>
                </div>
                <div className="d-flex flex-column justify-content-center align-items-center gradient-black" style={{ marginTop: "80px", paddingTop: "40px", paddingBottom: "40px", height: "800px" }}>
                        <h3>Help Melee Academy grow</h3>
                        <p className='text-center w-75 mb-3' style={{ minWidth: "320px", maxWidth: "700px" }}>
                            If this course helped you, consider contributing to support future lessons, platform improvements, and community projects. Every contribution helps continue building and expanding Melee Academy.
                        </p>
                        <button
                            className="rounded" // Use mt-auto to push the button to the bottom
                            style={{ backgroundColor: "#FFCC19", width: "250px", height: "45px", fontWeight: 600, border: "none", color: "black" }}
                            onClick={() => navigate('/pricing/contributions')}
                        >
                            Contribute
                        </button>
                    </div>
            </div>
            <Footer />
        </div>
    );
};

export default Pricing;